import { Badge, Group, List, Stack, Text } from '@mantine/core'
import { Callout, DataCard } from '@/components/ui'
import type { FirmwareVeredito, ModeloDeRelease, ReleaseDeFirmware } from '@/api/robo'
import { candidatas } from './candidatas'
import { HomologarRelease } from './HomologarRelease'

function Selo({ r, candidata }: { r: ReleaseDeFirmware; candidata: boolean }) {
  if (r.homologada) {
    const quando = new Date(r.homologada.em * 1000).toLocaleDateString('pt-BR')
    return (
      <Badge variant="light" color="inovareTeal">
        {r.homologada.por_nome ? `Homologada por ${r.homologada.por_nome} em ${quando}` : 'Homologada na implantação'}
      </Badge>
    )
  }
  return candidata ? <Badge variant="light" color="gray">Candidata</Badge> : null
}

/** O changelog do modelo do robô, marcando o que ele já roda e o que ainda
 * não tem. Some quando o perfil não é reconhecido — não há changelog a
 * mostrar para um firmware anterior ao versionamento. */
export function VersoesDoModelo({ firmware, modelos, podeHomologar = false }: {
  firmware: FirmwareVeredito
  modelos: ModeloDeRelease[]
  /** `robo:manage`: vê o "Homologar" na candidata mais nova. */
  podeHomologar?: boolean
}) {
  const modelo = modelos.find((m) => m.perfil === firmware.perfil)
  if (!modelo) return null
  const faltam = new Set(firmware.faltam.map((r) => r.versao))
  const acima = candidatas(modelo)
  const emBancada = new Set(acima.map((r) => r.versao))
  return (
    <DataCard title={`Versões do ${modelo.nome}`}>
      <Stack gap="md">
        {firmware.modelo_divergente && (
          <Callout variant="warning">
            O firmware deste robô é do {modelo.nome}, que não é o modelo cadastrado. Confira a placa antes de gravar.
          </Callout>
        )}
        {modelo.releases.map((r) => (
          <Stack key={r.versao} gap={4}>
            <Group gap={8}>
              <Text fw={600} ff="monospace">{r.versao}</Text>
              <Text size="xs" c="dimmed">{new Date(`${r.data}T12:00:00`).toLocaleDateString('pt-BR')}</Text>
              {r.versao === firmware.versao && <Badge variant="light" color="green">Em uso</Badge>}
              {faltam.has(r.versao) && <Badge variant="light" color="yellow">Falta neste robô</Badge>}
              <Selo r={r} candidata={emBancada.has(r.versao)} />
            </Group>
            {podeHomologar && r.versao === acima[0]?.versao && (
              <HomologarRelease perfil={modelo.perfil} versao={r.versao} />
            )}
            <List size="sm" withPadding>{r.mudancas.map((m) => <List.Item key={m}>{m}</List.Item>)}</List>
          </Stack>
        ))}
      </Stack>
    </DataCard>
  )
}
